import { Box } from "@mui/material";

interface MiniStepperProps {
  step: number;
}

const MiniStepper: React.FC<MiniStepperProps> = ({ step }) => {
  return (
    <Box display={"flex"} flexDirection={"column"} alignItems={"center"}>
      <p>Seu progresso</p>
      <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
        <Box
          sx={{
            width: "24px",
            height: "24px",
            backgroundColor: step >= 1 ? "#C2282B" : "#BDBEBF",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
        <Box
          sx={{
            width: "24px",
            height: "4px",
            backgroundColor: step >= 1 ? "#C2282B" : "#BDBEBF",
          }}
        />
        <Box
          sx={{
            width: "24px",
            height: "4px",
            backgroundColor: step >= 2 ? "#C2282B" : "#BDBEBF",
          }}
        />
        <Box
          sx={{
            width: "24px",
            height: "24px",
            backgroundColor: step >= 2 ? "#C2282B" : "#BDBEBF",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
        <Box
          sx={{
            width: "24px",
            height: "4px",
            backgroundColor: step >= 2 ? "#C2282B" : "#BDBEBF",
          }}
        />
        <Box
          sx={{
            width: "24px",
            height: "4px",
            backgroundColor: step >= 3 ? "#C2282B" : "#BDBEBF",
          }}
        />
        <Box
          sx={{
            width: "24px",
            height: "24px",
            backgroundColor: step >= 3 ? "#C2282B" : "#BDBEBF",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
      </Box>
    </Box>
  );
};
export default MiniStepper;
